import Backdrop from "@mui/material/Backdrop";
import CircularProgress from "@mui/material/CircularProgress";
import { useContext, useEffect } from "react";
import { useLocation } from "react-router-dom";
import { SessionContext } from "../Contexts/SessionContext";

export default function QuickAccess() {
    const location = useLocation();
    const params = new URLSearchParams(location.search);
    console.log(params);
    const { loadSession } = useContext(SessionContext);
    const sessionId = params.get('sessionId');

    useEffect(() => {
        if (sessionId) {
            loadSession(sessionId);
        }
    }, [sessionId]);

    return (
        <Backdrop
            open
            sx={{
                backgroundColor: '#ffffff',
                zIndex: (theme) => theme.zIndex.modal + 1,
            }}
        >
            <CircularProgress size="100px" color="primary" />
        </Backdrop>
    );
}
